import React, { useEffect } from 'react'
import ValorTotalOpcional from './ValorTotalOpcional'
import { BOTOES_PIX, CANCELAR, CONFIRMAR, INFO_COMPRA_PIX_MODAL } from '../../constantsCardOpcionais'
import { useOpcionais } from '../../../../contexts/OpcionaisContext'
import BotaoOpcionais from './BotaoOpcionais'
import { METODO_PAGAMENTO_PIX } from '../../../../constants'

// eslint-disable-next-line react/prop-types
const OpcionaisPagamentoPix = ( { fecharModal } ) => {
  const {
    comprarOpcional,
    infoPagamento,
    modalidadesEscolhidaOpcionais,
    setOpcionalSelecionado,
    setInfoPagamento
  } = useOpcionais()

  useEffect( () => {
    setInfoPagamento( {
      ...infoPagamento,
      'forma_pagamento': METODO_PAGAMENTO_PIX.inicial
    } )
  }, [] )

  return (
    <div>
      <p>{ INFO_COMPRA_PIX_MODAL }</p>

      <ValorTotalOpcional />

      <BotaoOpcionais
        botaoCancelar={{
          ...BOTOES_PIX[ CANCELAR ],
          'acaoBotaoCancelar': () => fecharModal()
        }}
        botaoConfirmar={{
          ...BOTOES_PIX[ CONFIRMAR ],
          'acaoBotaoConfirmar': () => {
            comprarOpcional( modalidadesEscolhidaOpcionais.length &&
                modalidadesEscolhidaOpcionais )
            setOpcionalSelecionado( [] )
          }
        }}
        modalidadesEscolhidaOpcionais={ modalidadesEscolhidaOpcionais }
      />
    </div>
  )
}

export default OpcionaisPagamentoPix
